import { render, staticRenderFns } from "./DoesMyEtherWalletSupportBitcoinOrOtherCoins.vue?vue&type=template&id=36f211dd&scoped=true&"
import script from "./DoesMyEtherWalletSupportBitcoinOrOtherCoins.vue?vue&type=script&lang=js&"
export * from "./DoesMyEtherWalletSupportBitcoinOrOtherCoins.vue?vue&type=script&lang=js&"
import style0 from "./DoesMyEtherWalletSupportBitcoinOrOtherCoins.vue?vue&type=style&index=0&id=36f211dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f211dd",
  null
  
)

export default component.exports